import moment from 'moment';
import {useEffect, useState} from 'react';
import {responseDataToUserSubscription} from '../mapping/userSubscriptionMapping';
import {
  cancelUserSubscription,
  getUserSubscription,
} from '../queries/userSubscription';

export const useUserSubscription = () => {
  const [userSubscriptions, setUserSubscriptions] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const fetchUserSubscriptions = async () => {
      try {
        setIsLoading(true);
        const data = await getUserSubscription();
        setUserSubscriptions(data.map(d => responseDataToUserSubscription(d)));
        setIsLoading(false);
      } catch {
        setIsLoading(false);
      }
    };

    fetchUserSubscriptions();
  }, []);

  const hasActiveSelfSubscription = () => {
    return userSubscriptions.some(
      subscription => subscription.isSelf && subscription.status === 'active',
    );
  };

  const getCurrentSubscription = () => {
    return userSubscriptions.find(
      subscription => subscription.status === 'active',
    );
  };

  const getSubscriptionHistory = () => {
    return userSubscriptions.filter(
      subscription => subscription.status !== 'active',
    );
  };

  const cancelCurrent = async () => {
    try {
      setIsLoading(true);
      await cancelUserSubscription();
      const data = await getUserSubscription();
      setUserSubscriptions(data.map(d => responseDataToUserSubscription(d)));
      setIsLoading(false);
    } catch {
      setIsLoading(false);
    }
  };

  const canRenew = () => {
    const now = moment();
    const current = getCurrentSubscription();
    const months = moment.duration(current._endDate.diff(now)).asMonths();
    return months <= 2;
  };

  return {
    userSubscriptions,
    getCurrentSubscription,
    getSubscriptionHistory,
    isLoading,
    cancelCurrent,
    canRenew,
    hasActiveSelfSubscription,
  };
};
